export default __webpack_public_path__ + "static/media/product-default.1208380b.png";